<li class="active sidebar2-checkbox-dropdown" [ngClass]="{ open: dropdownOpen, disabled: disableFilter }">
    <ul class="sub-menu-v2--dropdown">
        <li
            *ngFor="let item of statuses; let i = index"
            [ngClass]="{ 'dropdown-item-zero': item.Quantity < 1, 'dropdown-item-inset': item.Status !== 'All' }">
            <input
                legacy-css
                type="checkbox"
                name="status"
                [checked]="selections?.indexOf(convertKey(item)) ?? -1 > -1"
                [value]="item.Status"
                (click)="toggleSelection(item)"
                class="sub-menu-v2-cb"
                [id]="'menu_cb' + i" /><label [for]="'menu_cb' + i"
                >{{ item.Status | titlecase }}
                <span class="badge badge-stats pull-right">{{ item.Quantity }}</span>
            </label>
        </li>
    </ul>
</li>
